/**
 * A scroll behavior that always scrolls to the top of the page
 * after a transition.
 */
var ScrollToTopBehavior = {

  updateScrollPosition: function () {
    window.scrollTo(0, 0);
  }

};

module.exports = ScrollToTopBehavior;



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-router/modules/behaviors/ScrollToTopBehavior.js
 ** module id = 181
 ** module chunks = 0
 **/